<template>
    <div id="app">
        <el-container class="container">
            <el-header v-if="!$route.meta.keepAlive">
                <p>
                    <el-image
                            style="width: 20px; height: 20px; margin-right: 8px"
                            :src="require('./assets/images/logo.png')"
                            fit="contain"
                            v-if="isNeiwang"
                    ></el-image>
                    <span  style="font-size: 18px; color: #fff">{{isNeiwang?"二手物品采集智能搜索系统（六路通）":"六路通管理平台"}}</span>
                </p>
<!--                 <i-->
<!--          :class="['el-icon-s-operation', collapse ? 'icon-rotate' : '']"-->
<!--          @click="collapse = !collapse"-->
<!--        ></i>-->
                <div class="header-content">
                    <div class="header-location">
                        <el-link
                            href="http://77.1.44.53:7001/share/5cd2d521-534a-4b9f-9d33-dff331921622"
                            type="primary"
                            target="_blank"
                            v-if="isNeiwang"
                            :underline="false"
                            class="link-href"
                        >可视化展示</el-link>
                        <div v-if="isNeiwang">
                            <i class="el-icon-location-outline"></i>
                            <span>{{ userInfo.district }}</span>
                        </div>
                        <span>{{ "V2.1"}}</span>
                    </div>
                    <MsgUnread v-if="isNeiwang"></MsgUnread>
                    <el-dropdown>
                        <div class="header-user">
                            <p>
                                <img
                                    class="avatar-img"
                                    src="./assets/images/avatar.png"
                                />
                            </p>
                            <span>{{ userInfo.real_name }}</span>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <router-link to="/idcardcertification" v-if="!isNeiwang">
                            <el-dropdown-item>
                                    身份证认证
                            </el-dropdown-item>
                            </router-link>
                            <router-link to="/password">
                            <el-dropdown-item>
                                    重置登录密码
                            </el-dropdown-item>
                            </router-link>
                            <router-link to="/changephone" v-if="!isNeiwang">
                            <el-dropdown-item>
                                换绑手机号
                            </el-dropdown-item>
                            </router-link>
                            <router-link to="/personaldetail" v-if="!isNeiwang">
                            <el-dropdown-item>
                                详情
                            </el-dropdown-item>
                            </router-link>
                            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>
            <el-container>
                <el-aside
                    width="180px"
                    class="menu-aside"
                    v-if="!$route.meta.keepAlive"
                >
                    <el-menu
                        :default-active="activePath"
                        class="el-menu-vertical-demo"
                        @select="handleSelect"
                        background-color="#14152B"
                        text-color="#fff"
                        active-text-color="#0000ff"
                        router
                    >
                        <div
                                v-for="(item, index) in getter_menus"
                                :key="index"
                        >
                            <el-menu-item
                                    :index="item.code"
                                    :route="item.url"
                                    v-if="!item.children || item.children.length==0"
                            >
                                <i :class="item.icon || 'el-icon-menu'"></i>
                                <span slot="title">{{ item.name }}</span>
                            </el-menu-item>
                            <el-submenu
                                    :index="item.name"
                                    v-else
                            >
                                <template slot="title">
                                    <i :class="item.icon || 'el-icon-menu'"></i>
                                    <span>{{ item.name }}</span>
                                </template>
                                <el-menu-item-group>
                                    <el-menu-item
                                            :index="sub.code"
                                            :route="sub.url"
                                            v-for="(sub, i) in item.children"
                                            :key="i"
                                    >
                                        <span>{{ sub.name }}</span>
                                    </el-menu-item>
                                </el-menu-item-group>
                            </el-submenu>
                        </div>
                    </el-menu>
                </el-aside>
                <el-main>
                    <router-view />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import * as User from "@/api/user";
import MsgUnread from "@/components/MsgUnread.vue";
import config from "@/config";
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
    components: {
       MsgUnread
    },
    data() {
        return {
            abs_path: config.ABS_PATH,
            hosts: window.location.origin,
            iTotalRecords: 0,
            recordsDate: [],
            queryForm: {
                status: 0,
                pageSize: 10,
                curPage: 1
            },
            userInfo: {
                real_name: "登录用户",
                district: ""
            },
            collapse: false,
            activePath: "/",
            menus: [],
            isNeiwang: config.IS_NEIWANG==="1"
        };
    },
    computed: {
        ...mapGetters(["getter_menusDefult", "getter_menus", "getter_userinfo"])
    },
    watch: {
        $route() {
            this.setCurrentRoute();
            let userInfo = window.localStorage.getItem("userInfo");
            if (
                (this.$route.path.indexOf("login") == "-1" &&
                    this.getter_menus.length == 0) ||
                !JSON.parse(userInfo)
            ) {
                this.getUserInfo();
            }
        }
    },
    created() {
        this.setCurrentRoute();
        this.initialize();
    },
    mounted() {
        // let is_neiwang=config.IS_NEIWANG;
        let token = window.localStorage.getItem("token");
        let userInfo = window.localStorage.getItem("userInfo");
        if (
            (this.$route.path.indexOf("login") == "-1" &&
                this.getter_menus.length == 0) ||
            !JSON.parse(userInfo)
        ) {
            this.getUserInfo();
        }
    },
    methods: {
        ...mapMutations(["setMenus", "setUserInfo", "setMenusStore"]),
        initialize() {
            let userInfo = window.localStorage.getItem("userInfo");
            let menu = window.localStorage.getItem("menu");
            let btnMenusStore = window.localStorage.getItem("btnMenusStore");
            if (userInfo) {
                this.setUserInfo(JSON.parse(userInfo));

                this.userInfo = this.getter_userinfo;
            }
            if (menu) {
                this.setMenus(JSON.parse(menu));
            }
            if (btnMenusStore) {
                this.setMenusStore(JSON.parse(btnMenusStore));
            }
        },
        async getUserInfo() {
            try {
                let token = window.localStorage.getItem("token");
                if (!token || token == "") return;
                const result = await User.userInfo();
                console.log(result);
                this.userInfo = result.userinfo;
                this.getRoleMenu(this.userInfo.permissions_content);
                window.localStorage.setItem(
                    "userInfo",
                    JSON.stringify(this.userInfo)
                );

                // let menusArr = JSON.parse(this.userInfo.permissions_content);
                // if (!menusArr) {
                //     this.setMenus({ ...this.getter_menusDefult });
                // } else {
                //     let aaa = [];
                //     let bbb = JSON.parse(
                //         JSON.stringify(this.getter_menusDefult)
                //     );
                //     bbb.forEach((item2, index2) => {
                //         if (menusArr.indexOf(item2.value) > -1) {
                //             if (!item2.children) {
                //                 aaa.push(item2);
                //             } else {
                //                 let b = [];
                //                 item2.children.forEach((item3, index3) => {
                //                     if (menusArr.indexOf(item3.value) > -1) {
                //                         b.push(item3);
                //                     }
                //                 });
                //                 item2.children = b;
                //                 aaa.push(item2);
                //             }
                //         }
                //     });
                //     this.menus = aaa;
                //     this.setMenus(aaa);
                // }
            } catch (error) {
                console.log(error);
            }
        },
        //获取角色菜单
        async getRoleMenu(e) {
            try {
                // const result = await User.getSystemData({
                //     data_key: `menu_${e}`
                // });
                const result = await User.newGetSystemData({
                    role_id: e
                })

                const menuData = result;


                // this.setMenus(
                //     menuData ||
                //         JSON.parse(JSON.stringify(this.getter_menusDefult))
                // );
                //console.log(JSON.parse(JSON.stringify(this.getter_menusDefult)))
                let menu =menuData ;
                const resultCode = await User.newGetSystemCode({
                    role_id: e
                })

                let setMenusStore =resultCode;

             // let setMenusStore1 = [
             //        "_see",
             //        "user_see",
             //        "user_edit",
             //        "user_delete",
             //        "user_add",
             //        "search_list_see",
             //        "search_list_add",
             //        "search_list_edit",
             //        "search_list_delete",
             //        "classification_list_see",
             //        "classification_list_add",
             //        "classification_list_edit",
             //        "classification_list_delete",
             //        "transaction_list_see",
             //        "transaction_list_add",
             //        "transaction_list_edit",
             //        "transaction_list_delete",
             //        "goods_list_see",
             //        //"goods_list_add",
             //        "goods_list_edit",
             //        "goods_list_delete",
             //        "people_list_see",
             //        "people_list_add",
             //        "people_list_edit",
             //        "people_list_delete",
             //        "operation_list_see",
             //        "operation_list_delete",
             //        "operation_list_edit",
             //        "operation_list_add",
             //        "sys_user_list_see",
             //        "sys_user_list_add",
             //        "sys_user_list_edit",
             //        "sys_user_list_delete",
             //        "role_man_see",
             //        "role_man_add",
             //        "role_man_edit",
             //        "role_man_delete",
             //        "menu_man_see",
             //        "menu_man_delete",
             //        "menu_man_edit",
             //        "menu_man_add",
             //        "subaccount_list_see",
             //        "subaccount_list_add",
             //        "subaccount_list_edit",
             //        "subaccount_list_delete",
             //        "addressbook_list_see",
             //        "addressbook_list_add",
             //        "addressbook_list_edit",
             //        "addressbook_list_delete",
             //    ];
                // menu.forEach(item => {
                //     if (item.children) {
                //         if(item.url) {
                //             setMenusStore.push(
                //                 item.url.replace("/", "")
                //             );
                //         }
                //         item.children.forEach(item2 => {
                //             if(item.url) {
                //                 if (item2.children) {
                //                     setMenusStore.push(
                //                         item2.url.replace("/", "")
                //                     );
                //                     item2.children.forEach(item3 => {
                //
                //                         if(item2.url) {
                //                             item2.url.replace("/", "") + item2.code.replace(item2.pcode, "")
                //                         }
                //                     })
                //                 } else {
                //                     setMenusStore.push(
                //                         item.url.replace("/", "")+item2.code.replace(item2.pcode, "")
                //                     );
                //                 }
                //             }
                //             // if (item2.operation) {
                //             //     item2.operation.forEach(item3 => {
                //             //         setMenusStore.push(
                //             //             item2.value.replace("/", "") +
                //             //                 "_" +
                //             //                 item3
                //             //         );
                //             //     });
                //             // }
                //         });
                //
                //     } else {
                //         if (item.operation) {
                //             item.operation.forEach(item2 => {
                //                 if(item.url){
                //                     setMenusStore.push(
                //                         item.url.replace("/", "")+item2.code.replace(item2.pcode, "")
                //                     );
                //                 }
                //             });
                //         }
                //     }
                // });
                this.setMenusStore(setMenusStore);
                this.setMenus(menu);
                window.localStorage.setItem("menu", JSON.stringify(menu));
                window.localStorage.setItem(
                    "btnMenusStore",
                    JSON.stringify(setMenusStore)
                );
                // console.log(setMenusStore);
            } catch (error) {
                console.log(error);
                this.setMenus(
                    JSON.parse(JSON.stringify(this.getter_menusDefult))
                );
                this.setMenusStore([
                    "_see",
                    "user_see",
                    "user_edit",
                    "user_delete",
                    "user_add",
                    "search_list_see",
                    "search_list_add",
                    "search_list_edit",
                    "search_list_delete",
                    "classification_list_see",
                    "classification_list_add",
                    "classification_list_edit",
                    "classification_list_delete",
                    "transaction_list_see",
                    "transaction_list_add",
                    "transaction_list_edit",
                    "transaction_list_delete",
                    "goods_list_see",
                    "goods_list_add",
                    "goods_list_edit",
                    "goods_list_delete",
                    "people_list_see",
                    "people_list_add",
                    "people_list_edit",
                    "people_list_delete",
                    "operation_list_see",
                    "operation_list_delete",
                    "operation_list_edit",
                    "operation_list_add",
                    "sys_user_list_see",
                    "sys_user_list_add",
                    "sys_user_list_edit",
                    "sys_user_list_delete",
                    "role_man_see",
                    "role_man_add",
                    "role_man_edit",
                    "role_man_delete",
                    "menu_man_see",
                    "menu_man_delete",
                    "menu_man_edit",
                    "menu_man_add",
                    "subaccount_list_see",
                    "subaccount_list_add",
                    "subaccount_list_edit",
                    "subaccount_list_delete",
                    "addressbook_list_see",
                    "addressbook_list_add",
                    "addressbook_list_edit",
                    "addressbook_list_delete",
                ]);
            }
        },

        setCurrentRoute() {
            if (this.$route.path)
                this.activePath =
                    this.$route.path.substr(this.$route.path.length - 1, 1) ===
                        "/" && this.$route.path !== "/"
                        ? this.$route.path.substring(
                              0,
                              this.$route.path.length - 1
                          )
                        : this.$route.path;
        },
        handleSelect(key, keyPath) {
            // console.log(key, keyPath);
            this.activePath = keyPath[keyPath.length - 1];
        },
        async logout() {
            // await this.$axios.$delete('/auth/token/logout')
            window.localStorage.clear();
            this.setMenus([]);
            this.setUserInfo({});
            this.$router.replace({ path: "/login" });
        }
    }
};
</script>

<style lang="scss">
.el-cascader-menu .el-cascader-node .el-radio__inner{
  border-width: medium;
  border-color: #333333;
}

.el-scrollbar {
  height: 300px;
}
#app {
    // font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    width: 100%;
    background-color: #e8e8e8;
    display: flex;
}
.menu-aside {
    transition: all 0.3s;
}
.container {
    height: 100%;
    display: flex;
    .el-header {
        height: 64px !important;
        z-index: 1999;
        width: 100%;
        padding: 0 20px;
        display: flex;
        align-items: center;
        background: #14152b;
        box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
        > i {
            font-size: 22px;
            cursor: pointer;
            transition: all 0.3s;
            color: #fff;
        }
        .icon-rotate {
            transform: rotate(90deg);
        }
        > p {
            margin-right: 20px;
            display: flex;
            align-items: center;
            span {
                color: #ffffff;
                font-size: 18px;
            }
        }
        .header-content {
            flex: 1;
            text-align: right;
            display: flex;
            align-items: center;
            .header-location {
                font-size: 14px;
                color: #fff;
                flex: 1;
                margin-right: 70px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .link-href {
                    margin-right: 30px;
                    border: 1px solid #409eff;
                    padding: 2px 8px;
                    border-radius: 4px;
                }
            }
            .header-user {
                color: #fff;
                display: flex;
                align-items: center;
                font-size: 14px;
                position: relative;
                cursor: pointer;
                span {
                    margin: 0 4px;
                }
                .avatar-img {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    display: block;
                }
                .logout-img {
                    display: none;
                    position: absolute;
                    width: 134px;
                    height: 77px;
                    top: 35px;
                    right: -12px;
                }
            }
            .header-user:hover {
                .logout-img {
                    display: block;
                }
            }
            .el-button {
                color: #fff;
                margin-left: 10px;
            }
        }
    }
    .el-container {
        height: calc(100% - 64px);
        flex: 1;
    }
    .el-aside,
    .el-main {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .el-main-container {
        background: #030e20;
        overflow-y: auto;
    }
    .el-menu {
        border-right: none;
    }
}
.menu_aside_show {
    width: 180px !important;
}
.menu_aside_hide {
    width: 54px !important;
}
.el-aside {
    overflow: hidden;
    background: #14152b;
    .el-menu {
        background: #14152b;
        color: #fff;
    }
}
.el-menu-item {
    color: rgba(255, 255, 255, 0.6);
    transition: all 0.3s;
    > i {
        margin-right: 10px !important;
    }
}
.el-submenu {
    .el-menu-item {
        padding-left: 55px !important;
        line-height: 48px;
    }
    .el-submenu__title {
        > i {
            margin-right: 10px !important;
        }
    }
}

.el-menu-item-group__title {
    display: none;
}
.el-menu-item.is-active ::after {
    content: "";
    position: absolute;
    width: 3px;
    height: 100%;
    background: #0060e3;
    left: 0;
    top: 0;
}
.el-menu-item.is-active {
    position: relative;
    color: #fff !important;
    background: linear-gradient(
        90deg,
        rgba(14, 111, 255, 0.3) 0%,
        rgba(14, 111, 255, 0.04) 100%
    ) !important;
}

.el-submenu__title:hover {
    background: linear-gradient(
        90deg,
        rgba(14, 111, 255, 0.3) 0%,
        rgba(14, 111, 255, 0.04) 100%
    ) !important;
}
.el-menu-item:focus,
.el-menu-item:hover {
    color: #fff;
    i {
        color: #fff;
    }
    background: linear-gradient(
        90deg,
        rgba(14, 111, 255, 0.3) 0%,
        rgba(14, 111, 255, 0.04) 100%
    ) !important;
}
.el-menu-item,
.el-submenu__title {
    line-height: 54px;
}
.el-menu-item *,
.el-submenu__title * {
    // vertical-align: unset;
}
.el-main {
    padding: 0 !important;
}
.paging-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.row--flex {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    .el-col-24 {
        width: auto;
    }
    .el-form-item {
        // width: 270px;
    }
    .queryForm-btn {
        margin-bottom: 22px;
    }
}
.el-dropdown-menu__item a {
    color: #606266;
    list-style: none;
}
</style>
